import React, { useMemo } from "react";
import { SectionTitle } from "@components";
import { useAppDispatch, useAppSelector } from "@hooks";
import { setCV } from "@store";
import { createAIToolPoint } from "@utils";
import { HeadingIds } from "@constants";
import { AIToolsList } from "./components/AIToolsList/AIToolsList";
import { fields } from "./localization";
import commonStyles from "../../CV.common.scss";
export function AITools() {
    var _a;
    const dispatch = useAppDispatch();
    const { cv, isTriedToSave } = useAppSelector((state) => state.cv);
    const { language } = useAppSelector((state) => state.ui);
    const { title, addLabel } = fields(language);
    const aiTools = ((_a = cv === null || cv === void 0 ? void 0 : cv.aiToolsDisplay) === null || _a === void 0 ? void 0 : _a.length)
        ? cv.aiToolsDisplay
        : [createAIToolPoint()];
    const hideAITools = (cv === null || cv === void 0 ? void 0 : cv.hideAITools) || false;
    const setAITools = (aiToolsDisplay) => {
        dispatch(setCV(Object.assign(Object.assign({}, cv), { aiToolsDisplay })));
    };
    // Create validation errors object based on current AI tools state
    const validationErrors = useMemo(() => {
        const errors = {};
        if (isTriedToSave) {
            aiTools.forEach((tool, i) => {
                const hasName = tool.name.trim() !== "";
                const hasDescription = tool.description.trim() !== "";
                // If Name is filled but Description is empty → highlight Description
                if (hasName && !hasDescription) {
                    errors[i] = "description";
                }
                // If Description is filled but Name is empty → highlight Name
                else if (hasDescription && !hasName) {
                    errors[i] = "name";
                }
                // Note: if both are empty or both are filled, no validation error
            });
        }
        return errors;
    }, [aiTools, isTriedToSave]);
    const handleAdd = () => {
        if (aiTools.length === 0) {
            setAITools([createAIToolPoint(), createAIToolPoint()]);
        }
        else {
            setAITools([...aiTools, createAIToolPoint()]);
        }
    };
    return (React.createElement("section", { id: HeadingIds.AITools, className: commonStyles.section },
        React.createElement(SectionTitle, { title: title, handleAdd: handleAdd, isSectionHidden: hideAITools, addButtonLabel: addLabel, handleSectionHide: () => {
                dispatch(setCV(Object.assign(Object.assign({}, cv), { hideAITools: !hideAITools })));
            } }),
        React.createElement(AIToolsList, { aiTools: aiTools, onEdit: setAITools, readOnly: hideAITools, showValidation: isTriedToSave, validationErrors: validationErrors })));
}
